// Copyright (c) 2017 Deere & Company

import ReportCriteriaContainer from './report-criteria';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    canExport: state.reports.pipHistory.report.length > 0,
    criteria: state.reports.pipHistory.criteria,
    gridApi: state.reports.pipHistory.gridApi
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => {

    const {
        readPipHistory,
        resetCriteria,
        resetReport,
        toggleReportIsScrollable,
        updateCriteria,
        updateShowNoResultsFound
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            readPipHistory,
            resetCriteria,
            resetReport,
            toggleReportIsScrollable,
            updateCriteria,
            updateShowNoResultsFound
        }
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(ReportCriteriaContainer);



// WEBPACK FOOTER //
// ./src/reports/pip-history/components/report-criteria/index.js